{
  "hero": {
    "eyebrow": "Per i produttori",
    "title": "Ricevi cassa anticipata dai tuoi impianti e",
    "highlight": "fai derisking ",
    "subtitle": "DEC Energy si integra nella struttura finanziaria del tuo portafoglio di impianti, senza generare conflitti e permettendoti di ottenere liquidità immediata."
  },
  "layers": {
    "eyebrow": "Dove si inserisce DEC Energy",
    "title": "Una soluzione plug-in che genera cassa immediata e derisking",
    "body": "Indipendentemente dalla tariffa selezionata e dalle modalità di finanziamento, la soluzione DEC Energy si applica su asset già in esercizio.",
    "layer1": {
      "label": "Tariffa / Route-to-market",
      "chips": [
        "Merchant",
        "PPA",
        "Energy Release",
        "FER X",
        "FER 1",
        "Combinazioni"
      ]
    },
    "layer2": {
      "label": "Modalità di finanziamento",
      "chips": [
        "Equity",
        "Project financing",
        "Green bond",
        "Bridge loan",
        "Mezzanino",
        "Rifinanziamento"
      ]
    },
    "dec": {
      "label": "DEC Energy",
      "body": "Contratto applicabile su asset già in esercizio. Permette al produttore di incassare subito il valore attualizzato dei flussi netti che l'asset genererà nei prossimi dieci anni."
    },
    "nots": [
      {
        "title": "No equity",
        "body": "Non acquistiamo quote dell'asset"
      },
      {
        "title": "No debt",
        "body": "Non sussiste un repayment basato su un tasso di interesse nel tempo"
      },
      {
        "title": "No variazioni",
        "body": "Invariati route-to-market e contratti di finanziamento attivi"
      }
    ]
  },
  "serve": {
    "eyebrow": "A chi ci rivolgiamo",
    "title": "Eleviamo la tua strategia di portafoglio",
    "sub": "Soddisfando le esigenze di piccoli produttori, IPP e utilities",
    "more": "scopri di più",
    "tiles": [
      {
        "target": "Piccolo produttore",
        "promise": "Liquidità immediata\n senza complessità"
      },
      {
        "target": "IPP",
        "promise": "Ottimizza l'allocazione\ndella tua equity"
      },
      {
        "target": "Utility",
        "promise": "Accelera la tua transizione \nenergetica indipendente"
      }
    ]
  },
  "overview": {
    "head": "Incasso immediato",
    "sub": [
      "senza vendere l'asset",
      "senza debito"
    ],
    "cowLine": "No, non è un finanziamento",
    "ctaTitle": "Pronto a liberare il capitale dei tuoi impianti?"
  },
  "cases": {
    "eyebrow": "Casi di successo",
    "heading": "Per asset di qualsiasi dimensione, route-to-market e modalità di finanziamento",
    "sub": "Attualizziamo i flussi di cassa futuri in base ai tuoi obiettivi.",
    "items": {
      "ipp-light": {
        "title": "Produttore regionale riceve immediatamente 710'000 € con DEC Energy",
        "body": "Un piccolo produttore, dopo 3 mesi dall’attivazione di un asset da 5.24 MWp in cui ha investito 1'181'801 € di capitale proprio, ottiene 710'000 € con cui finanzierà la realizzazione di nuovi progetti.",
        "link": "Vai alla sezione per piccoli produttori"
      },
      "ipps": {
        "title": "Produttore indipendente internazionale ottimizza i propri asset con DEC Energy",
        "body": "Uno dei principali IPP europei, siglando un accordo da 13.67 MWp con DEC Energy, riduce del 51% l’equity investita nel singolo asset, riducendo i rischi e incrementando il proprio IRR di 60 punti base",
        "link": "Vai alla sezione per IPP"
      },
      "utility": {
        "title": "Utility supporta la propria transizione energetica indipendente con DEC Energy",
        "body": "Una delle top 15 utilities attive sul territorio italiano, tramite un accordo su un asset da 18.54 MWp, supporta la crescita dei propri asset di investimento diretto in energia rinnovabile senza ulteriore indebitamento.",
        "link": "Vai alla sezione per Utility"
      }
    }
  }
}
